<template>
    <div id="header">
        <!--头部导航条-->
        <div class="header">
            <router-link to="/" class="logo">
                <img src="http://yopoo.oss-cn-beijing.aliyuncs.com/logo.png"/>
            </router-link>
            <div style="display: flex;align-items: center;justify-content: flex-end;">
                <ul class="nav-list">
                    <li class="nav-list-item">
                        <router-link to="/" exact>首页</router-link>
                    </li>
                    <li class="nav-list-item">
                        <router-link to="/baike">艺人百科</router-link>
                    </li>
                    <li class="nav-list-item">
                        <router-link to="/juzu">新片速递</router-link>
                    </li>
                    <li class="nav-list-item">
                        <router-link to="/hot">娱情一线</router-link>
                    </li>
                    <li class="nav-list-item">
                        <router-link to="/video">娱人工访</router-link>
                    </li>
                </ul>
                <div class="login-btn">
                    <router-link class="login" to='/login'>登录</router-link>
                    <router-link class="login" to='/register' style="margin-left: 20px">注册</router-link>
                    <div class="clearfix"></div>
                </div>
                <div class="login-btn">
          <span class="islogin">
          <img :src="picture" width="50" height="50" style="border-radius:50%">
          <span>{{username}}</span>
          <span @click="admin">个人中心</span>
            <input class="logout" type="button" @click="logout" value="注销">
          </span>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import storage from '../storage/storage.js'

    $(function () {
        var token = storage.get('token')  //引用jq判断登录页面的显示与否
        if (token == null) {
            $('.login').show()
            $('.islogin').hide()
        }
        else {
            $('.login').hide()
            $('.islogin').show()
        }
    })
    export default {
        data() {
            return {
                name: '',
                search: '',
                username: '',
                picture: '',
            }
        },
        methods: {
            admin() {
                var iden = storage.get('iden');   //引用jq判断后台显示的路径

                if (iden == 1 || iden == 3) {
                    this.$router.push('/per_admin/perinfor')
                }
                if (iden == 2) {
                    this.$router.push('/group_admin/release')
                }
            },

            searchData() {
                if (this.search == '') {
                    this.$message({
                        message: '抱歉，您没有输入任何内容！',
                        type: 'error',
                        center: true
                    });
                    return false
                } else {
                    this.search = storage.set('search', this.search)
                    this.$router.push({
                        path: '/search',
                    })
                }
            },
            logout() {
                this.$message({
                    message: '您已注销！',
                    type: 'warning',
                    center: true
                });
                storage.clear() //删除localstroage存储的用户信息
                setTimeout(() => {
                    this.$router.push('/')
                    location.reload()
                }, 2500);
            }
        },
        mounted() {

            login: {

                var username = storage.get('username')
                var picture = storage.get('picture')
                var token = storage.get('token') //需要登录获取token否则header头无内容
                if (username, picture) {
                    this.picture = picture;
                    this.username = username;
                    this.token = token;
                }

            }
            if (token != null) {
                var nowDate = new Date();
                var logintime = storage.get('logintime') //获取登录时间戳
                var newData = nowDate.getTime() //获取当前时间戳
                var Timing = 14400000 //定义单位有效时间
                // var Timing = 30000 //30s
                var outtime = logintime + Timing //定义有效时间戳总值
                if (newData > outtime) {
                    alert('登录超时，请重新登录！')
                    storage.clear() //删除localstroage存储的用户信息
                    setTimeout(() => {
                        this.$router.push('/')
                        location.reload()
                    }, 2000);

                }

            }
        }
    }
</script>
<style lang="scss" scoped>
    .inner {
        width: 1200px;
        height: 100%;
        display: block;
        margin: 0 auto;
    }

    .header {
        background: #000;
        height: 66px;
        position: relative;
    }

    .header .logo {
        width: 140px;
        height: 32px;
        display: inline-block;
        position: absolute;
        top: 17px;
        left: 60px;
    }

    .header .logo img {
        width: 100%;
        height: 100%;
    }

    .header .nav-list li {
        display: inline-block;
        text-align: center;
        height: 66px;
        line-height: 66px;
        padding: 0 20px;
        position: relative;
    }

    .header .nav-list li a {
        display: block;
        color: #fff;
        font-size: 18px;
        position: relative;
    }

    .header .nav-list li:hover > a,
    .header .nav-list li.active > a {
        position: relative;
    }

    .header .nav-list li:hover > a.active:after,
    .header .nav-list li > a.active:after {
        content: '';
        width: 100%;
        height: 1px;
        position: absolute;
        left: 0;
        bottom: 12px;
        background: #fff;
    }

    .header .nav-list li .two-nav {
        position: absolute;
        bottom: -40px;
        left: 0;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #fff;
        background: #000;
        padding: 0 20px;
        display: none;
        z-index: 999;
    }

    .header .nav-list li .two-nav.active {
        display: block;
    }

    .header .nav-list li .two-nav a {
        font-size: 14px;
    }

    .islogin img {
        vertical-align: middle;
    }

    .login-btn {
        margin-left: 5vw;
        margin-right: 2vw;
    }

    .peradmin, .groupadmin, .islogin {
        color: #fff;
    }

    .islogin img, .islogin span, .islogin a {
        margin-right: 20px;
        cursor: default;
    }

    .islogin span {
        font-size: 16px;
    }

    .islogin input:hover {
        color: red;
    }

    .login {
        display: block;
        height: 40px;
        color: #ccc;
        text-align: center;
        line-height: 40px;
        border-radius: 20px;
    }

    .login:hover {
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue